import { render } from "./chartSubTitle.vue?vue&type=template&id=f84d2062"
import script from "./chartSubTitle.vue?vue&type=script&lang=js"
export * from "./chartSubTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__